
import { Delivery } from '@/types/delivery';
import { createDeliveryItem } from './delivery-factory';
import { companies, contacts, teams } from './delivery-constants';

// Create the delivery items using the factory function
export const PLACEHOLDER_DELIVERY: Delivery[] = [
  createDeliveryItem(
    '1',
    'Website Redesign',
    'Overhaul the company website with a modern design and improved UX',
    companies.techCorp,
    contacts.techCorp,
    'development',
    '2025-05-15',
    { team: teams.development, progress: 65 }
  ),
  
  createDeliveryItem(
    '2',
    'Mobile App Development',
    'Create a cross-platform mobile application for customer engagement',
    companies.mediHealth,
    contacts.mediHealth,
    'design',
    '2025-06-30',
    { team: teams.design, progress: 40 }
  ),
  
  createDeliveryItem(
    '3',
    'Analytics Dashboard',
    'Build a real-time analytics dashboard for executive reporting',
    companies.investGroup,
    contacts.investGroup,
    'planning',
    '2025-07-10',
    { team: teams.planning, progress: 15 }
  ),
  
  createDeliveryItem(
    '4',
    'E-commerce Platform',
    'Build a scalable online shopping platform with inventory management',
    companies.retailPlus,
    contacts.retailPlus,
    'testing',
    '2025-05-30',
    { team: teams.testing, progress: 85 }
  ),
  
  createDeliveryItem(
    '5',
    'Brand Identity Refresh',
    'Update visual identity including logo, colors, and brand guidelines',
    companies.ecoSolutions,
    contacts.ecoSolutions,
    'approval',
    '2025-04-25',
    { team: teams.marketing, progress: 90 }
  ),
  
  createDeliveryItem(
    '6',
    'CRM Integration',
    'Integrate customer relationship management system with existing platforms',
    companies.techCorp,
    contacts.techCorp,
    'discovery',
    '2025-07-15',
    { team: teams.cloud, progress: 10 }
  ),
  
  createDeliveryItem(
    '7',
    'Content Management System',
    'Implement a custom CMS for easy content updates and management',
    companies.mediHealth,
    contacts.mediHealth,
    'scoping',
    '2025-06-10',
    { team: teams.content, progress: 25 }
  ),
  
  createDeliveryItem(
    '8',
    'Payment Gateway Integration',
    'Add secure payment processing capabilities to existing platform',
    companies.retailPlus,
    contacts.retailPlus,
    'proposal',
    '2025-05-20',
    { team: teams.payment, progress: 30 }
  ),
  
  createDeliveryItem(
    '9',
    'Security Audit & Implementation',
    'Comprehensive security review and implementation of best practices',
    companies.investGroup,
    contacts.investGroup,
    'review',
    '2025-06-05',
    { team: teams.security, progress: 80 }
  ),
  
  createDeliveryItem(
    '10',
    'Cloud Migration',
    'Migrate on-premise infrastructure to cloud-based solutions',
    companies.ecoSolutions,
    contacts.ecoSolutions,
    'deployment',
    '2025-04-30',
    { team: teams.devops, progress: 95 }
  ),
  
  createDeliveryItem(
    '11',
    'Staff Training Program',
    'Develop and deliver comprehensive training for new systems',
    companies.mediHealth,
    contacts.mediHealth,
    'training',
    '2025-07-25',
    { team: teams.training, progress: 70 }
  ),
  
  createDeliveryItem(
    '12',
    'Ongoing Maintenance',
    'Regular updates, security patches, and performance optimization',
    companies.techCorp,
    contacts.techCorp,
    'support',
    '2025-12-31',
    { team: teams.support, progress: 50 }
  ),
  
  createDeliveryItem(
    '13',
    'Social Media Strategy',
    'Develop comprehensive social media presence and content calendar',
    companies.retailPlus,
    contacts.retailPlus,
    'discovery',
    '2025-06-15',
    { team: teams.social, progress: 5 }
  ),
  
  createDeliveryItem(
    '14',
    'Data Analytics Platform',
    'Build custom analytics solution for business intelligence',
    companies.investGroup,
    contacts.investGroup,
    'development',
    '2025-08-10',
    { team: teams.data, progress: 60 }
  ),
  
  createDeliveryItem(
    '15',
    'Mobile App Phase 2',
    'Add advanced features and functionality to existing mobile app',
    companies.mediHealth,
    contacts.mediHealth,
    'planning',
    '2025-09-15',
    { team: teams.mobileApp, progress: 20 }
  )
];
